<template>
  <v-card
    flat
    class="my-5"
    style="box-shadow: none"
    v-if="creditCard"
    :style="
      $vuetify.theme.dark
        ? 'background-color: #121212'
        : 'background-color: transparent'
    "
  >
    <div class="credit-card-wrapper">
      <div class="credit-card-from">
        <v-text-field
          id="v-card-number"
          ref="number"
          data-card-field
          autocomplete="off"
          :maxlength="cardNumberMaxLength"
          @input="changeNumber"
          name="number"
          outlined
          dense
          v-mask="creditCardMask"
          label="Número do Cartão"
          required
          :disabled="disabled"
          data-vv-name="Número do Cartão"
          v-model="creditCard.cardNumber"
          :rules="numberRules"
          :validate-on-blur="true"
        >
        </v-text-field>
        <v-text-field
          id="v-card-name"
          name="name"
          label="Nome (igual ao cartão)"
          outlined
          dense
          data-card-field
          required
          :disabled="disabled"
          @input="changeName"
          :rules="nameRules"
          :validate-on-blur="true"
          v-model="creditCard.cardName"
        >
        </v-text-field>
        <div class="fields-row">
          <v-autocomplete
            aria-label="Card Month"
            title="Month"
            v-model="creditCard.cardMonth"
            data-card-field
            append-icon="none"
            :items="months"
            :search-input.sync="monthSearch"
            id="v-card-month"
            label="Mês"
            outlined
            dense
            auto-select-first
            masked="true"
            :disabled="disabled"
            @input="changeMonth"
            :rules="monthRules"
            :validate-on-blur="true"
          >
          </v-autocomplete>
          <v-autocomplete
            id="v-card-year"
            v-model="creditCard.cardYear"
            name="expiryYear"
            label="Ano"
            :items="cardYears"
            :search-input.sync="yearSearch"
            outlined
            dense
            auto-select-first
            data-card-field
            append-icon="none"
            :disabled="disabled"
            @input="changeYear()"
            :rules="yearRules"
            :validate-on-blur="true"
          >
          </v-autocomplete>
          <v-text-field
            name="v-card-cvv"
            label="CVV"
            v-model="creditCard.cardCvv"
            outlined
            dense
            v-mask="'####'"
            :disabled="disabled"
            :id="this.cardInputFields.cardCvv"
            maxlength="4"
            data-card-field
            autocomplete="off"
            @input="changeCvv()"
            :rules="cvvRules"
            :validate-on-blur="true"
          >
          </v-text-field>
        </div>
        <payment-installments
          :installments="available_installments"
          paymentMethod="credit_card"
          @onInstallmentChange="emitForCheckoutSelectedInstallment"
        >
        </payment-installments>
      </div>

      <vue-paycard
        ref="c"
        style="min-width: 410px"
        :is-card-number-masked="false"
        :value-fields="creditCard"
        :input-fields="this.cardInputFields"
        :labels="this.cardLabels"
        :background-image="this.cardImage"
        v-if="$vuetify.breakpoint.lgAndUp"
      />
    </div>
  </v-card>
</template>

<style lang="scss" scoped>
.credit-card-wrapper {
  display: flex;
  flex-wrap: nowrap;
  gap: 20px;
}
.credit-card-from {
  display: flex;
  flex-direction: column;
  margin-top: 5px;
  width: 100%;
  .fields-row {
    display: flex;
    flex-wrap: nowrap;
    column-gap: 10px;
  }
}
</style>

<script>
import { mask } from "vue-the-mask";
import { VuePaycard } from "vue-paycard";
import PaymentInstallments from "./PaymentInstallments";

const defaultProps = {
  cardName: "",
  cardNumber: "",
  cardMonth: "",
  cardYear: "",
  cardCvv: "",
};

export default {
  directives: { mask },
  components: { PaymentInstallments, VuePaycard },
  props: {
    creditCard: {
      required: true,
      default: defaultProps,
    },
    selectedInstallment: {
      required: false,
    },
    isValid: {
      default: false,
      type: Boolean,
      required: false,
    },
    disabled: {
      default: false,
      type: Boolean,
      required: false,
    },
    available_installments: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      numberRules: [
        (v) => !!v || "Campo Obrigatório",
        (v) => (v && v.length >= 18) || "Campo incompleto",
      ],
      nameRules: [
        (v) => !!v || "Campo Obrigatório",
        (v) =>
          (v && v.length >= 5) ||
          "Nome deve ser igual ao que consta no cartão. ",
      ],
      monthRules: [(v) => !!v || "Campo Obrigatório"],
      yearRules: [(v) => !!v || "Campo Obrigatório"],
      cvvRules: [
        (v) => !!v || "Campo Obrigatório",
        (v) => (v && v.length >= 3) || "Campo incompleto",
      ],
      creditCardMask: "#### #### #### ####",
      minCardYear: new Date().getFullYear(),
      mainCardNumber: "",
      cardYears: [],
      cardNumberMaxLength: 19,
      cardInputFields: {
        cardNumber: "v-card-number",
        cardName: "v-card-name",
        cardMonth: "v-card-month",
        cardYear: "v-card-year",
        cardCvv: "v-card-cvv",
      },
      cardLabels: {
        cardName: "Nome Completo",
        cardHolder: "Nome no Cartão",
        cardMonth: "MM",
        cardYear: "AA",
        cardExpires: "Validade",
        cardCvv: "CVV",
      },
      cardImage: null,
      installmentWasSelected: false,
      months: [
              '01',
              '02',
              '03',
              '04',
              '05',
              '06',
              '07',
              '08',
              '09',
              '10',
              '11',
              '12'
            ],
      monthSearch: null,
      yearSearch: null
    };
  },
  watch: {
    cardYear() {
      if (this.creditCard.cardMonth < this.minCardMonth) {
        this.creditCard.cardMonth = "";
      }
    },
    monthSearch(value) {
      const filtered = this.months.filter(m =>
        m.startsWith(value)
      )
      if (filtered.length === 1) {
        this.creditCard.cardMonth = filtered[0]
      }
    },
    yearSearch(value) {
      const filtered = this.cardYears.filter(m => {
        return m == value
    })
      if (filtered.length === 1) {
        this.creditCard.cardYear = filtered[0];
      }
    }
  },
  created() {
    this.initCheckout();
  },
  methods: {
    initCheckout() {
      this.creditCard = defaultProps;
      this.loadSelects();
      this.setRandomCardImage();
    },
    setRandomCardImage() {
      const isSharkImage = Math.round(Math.random() * 1);
      if (isSharkImage) {
        const imgNumber = Math.round(Math.random() * (4 - 1) + 1);
        this.cardImage = `/img/checkout/cards/${imgNumber}.jpg`;
      } else {
        this.cardImage = null;
      }
    },
    loadSelects() {
      this.cardYears = [];
      for (let i = this.minCardYear; i <= this.minCardYear + 12; i++) {
        this.cardYears.push(i.toString());
      }
    },
    changeName(e) {
      this.creditCard.cardName = e;
      this.$emit("input-card-name", this.creditCard.cardName);
      this.checkCard();
    },
    changeNumber(e) {
      this.creditCard.cardNumber = e;
      const value = this.creditCard.cardNumber.replace(/\D/g, "");
      // american express, 15 digits
      if (/^3[47]\d{0,13}$/.test(value)) {
        this.creditCard.cardNumber = value
          .replace(/(\d{4})/, "$1 ")
          .replace(/(\d{4}) (\d{6})/, "$1 $2 ");
        this.cardNumberMaxLength = 18;
      } else if (/^3(?:0[0-5]|[68]\d)\d{0,11}$/.test(value)) {
        // diner's club, 14 digits
        this.creditCard.cardNumber = value
          .replace(/(\d{4})/, "$1 ")
          .replace(/(\d{4}) (\d{6})/, "$1 $2 ");
        this.cardNumberMaxLength = 16;
      } else if (/^62[0-9]\d*/.test(value)) {
        this.creditCard.cardNumber = value
          .replace(/(\d{6})/, "$1 ")
          .replace(/(\d{6}) (\d{7})/, "$1 $2 ")
          .replace(/(\d{6}) (\d{7}) (\d{6})/, "$1 $2 $3 ")
          .replace(/(\d{5}) (\d{5}) (\d{5}) (\d{4})/, "$1 $2 $3 $4");
        this.cardNumberMaxLength = 21;
      } else if (/^\d{0,16}$/.test(value)) {
        // regular cc number, 16 digits
        this.creditCard.cardNumber = value
          .replace(/(\d{4})/, "$1 ")
          .replace(/(\d{4}) (\d{4})/, "$1 $2 ")
          .replace(/(\d{4}) (\d{4}) (\d{4})/, "$1 $2 $3 ");
        this.cardNumberMaxLength = 19;
      }

      if (e.inputType === "deleteContentBackward") {
        const lastChar = this.creditCard.cardNumber.substring(
          this.creditCard.cardNumber.length,
          this.creditCard.cardNumber.length - 1,
        );
        if (lastChar === " ") {
          this.creditCard.cardNumber = this.creditCard.cardNumber.substring(
            0,
            this.creditCard.cardNumber.length - 1,
          );
        }
      }
      this.$emit("input-card-number", this.creditCard.cardNumber);
      this.checkCard();
    },
    changeMonth() {
      this.$emit("input-card-month", this.creditCard.cardMonth);
      this.validateExpiryDate();
      this.checkCard();
    },
    changeYear() {
      this.$emit("input-card-year", this.creditCard.cardYear);
      this.validateExpiryDate();
      this.checkCard();
    },
    changeCvv(e) {
      // this.creditCard.cardCvv = e
      this.$emit("input-card-cvv", this.creditCard.cardCvv);
      this.checkCard();
    },
    checkCard() {
      this.formHasErrors().then(() => {
        let ready = false;
        if (
          this.creditCard.cardName.length > 5 &&
          this.creditCard.cardNumber.length <= this.cardNumberMaxLength &&
          this.creditCard.cardCvv.length >= 3 &&
          this.installmentWasSelected &&
          this.errors.items.length === 0
        ) {
          ready = true;
        } else {
          ready = false;
        }

        this.$emit("isCardValid", ready);
      });
    },

    validateExpiryDate() {
      if (!this.creditCard.cardMonth || !this.creditCard.cardYear) {
        return false;
      }

      const selectedDate = new Date(
        this.creditCard.cardYear,
        this.creditCard.cardMonth - 1,
      );
      const currentDate = new Date();
      currentDate.setDate(0);

      if (selectedDate < currentDate) {
        this.errors.add({
          field: "expiry",
          msg: "Data inválida.",
        });
        return false;
      }
      this.errors.remove("expiry");
      return true;
    },
    hasInstallments() {
      let ret = false;
      // console.log('credit card', this.creditCard)
      if (this.creditCard === undefined) {
        ret = true;
      }
      if (this.creditCard.installments.length === 0) {
        ret = true;
      }
      return ret;
    },
    emitForCheckoutSelectedInstallment(selectedInstallment) {
      console.log(">>> repassando parcela selecionada", selectedInstallment);
      this.installmentWasSelected = true;
      this.checkCard();
      this.$emit("onInstallmentChange", selectedInstallment);
    },
  },
  computed: {
    minCardMonth() {
      if (this.creditCard.cardYear === this.minCardYear)
        return new Date().getMonth() + 1;
      return 1;
    },
  },
};
</script>
